export const PlusSalaryCard = {
  info: [
    "Caja de Ahorro Pesos",
    "Caja de Ahorro Dólares",
    "Tarjeta de Débito Visa Soy Santander",
  ],
  movement: [
    "8 extracciones mensuales sin costo en cajeros Banred",
    "Depósitos por buzoneras sin costo",
    "Transferencias entre cuentas Santander sin costo",
    "8 transferencias en plaza mensuales sin costo",
  ],
  coste: ["Costo mensual 60 UI"],
  benefit: [
    "Descuentos y beneficios en todo el país",
    "Canje de Puntos Soy Santander",
    "1 punto = 1 peso",
  ],
};

export const BasicSalaryCard = {
  info:[
    "Caja de Ahorro Pesos",
    "Caja de Ahorro Dólares",
    "Tarjeta de Débito Visa Santander",
  ],
  movement:  [
    "8 extracciones mensuales sin costo en cajeros Banred",
    "Depósitos por buzoneras sin costo",
    "Transferencias entre cuentas Santander sin costo",
    "8 transferencias en plaza mensuales sin costo"
  ],
  coste: ["Sin costo de mantenimiento mensual"],
  benefit: [],
};